/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsBase {
    type: string;

    protected setDiscriminator(type: string) {
        this.type = type;
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsBase.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsBase>): ServiceAccountCredentialsBase {
        let obj = Object.assign(new ServiceAccountCredentialsBase(), model);
        ServiceAccountCredentialsBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsBase>): ServiceAccountCredentialsBase {
        if (!model) return null;
        return ServiceAccountCredentialsBase.newInstance(<ServiceAccountCredentialsBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsBase) {
        if (!obj) return;

        models.ServiceAccountCredentialsBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsBase): boolean {
        switch (obj.type)
        {
            case "ServiceAccountCredentialsBaseForAiPlatform":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsBaseForAiPlatform.prototype);
                break;
            case "ServiceAccountCredentialsBaseForAws":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsBaseForAws.prototype);
                break;
            case "ServiceAccountCredentialsBaseForAzure":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsBaseForAzure.prototype);
                break;
            case "ServiceAccountCredentialsBaseForAzureApiKey":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsBaseForAzureApiKey.prototype);
                break;
            case "ServiceAccountCredentialsBaseForAzureApplication":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsBaseForAzureApplication.prototype);
                break;
            case "ServiceAccountCredentialsBaseForAzureCsp":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsBaseForAzureCsp.prototype);
                break;
            case "ServiceAccountCredentialsBaseForAzureSecurityGraph":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsBaseForAzureSecurityGraph.prototype);
                break;
            case "ServiceAccountCredentialsBaseForGcp":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsBaseForGcp.prototype);
                break;
            case "ServiceAccountCredentialsBaseForGcpOauthProtocol":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsBaseForGcpOauthProtocol.prototype);
                break;
            case "ServiceAccountCredentialsBaseForGcpServiceAccountProtocol":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsBaseForGcpServiceAccountProtocol.prototype);
                break;
            case "ServiceAccountCredentialsBaseForKubernetesCluster":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsBaseForKubernetesCluster.prototype);
                break;
            case "ServiceAccountCredentialsBaseForKubernetesClusterAws":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsBaseForKubernetesClusterAws.prototype);
                break;
            case "ServiceAccountCredentialsBaseForKubernetesClusterGcp":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsBaseForKubernetesClusterGcp.prototype);
                break;
            case "ServiceAccountCredentialsBaseForOci":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsBaseForOci.prototype);
                break;
            case "ServiceAccountCredentialsBaseForOpenStack":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsBaseForOpenStack.prototype);
                break;
            case "ServiceAccountCredentialsBaseForSaasAws":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsBaseForSaasAws.prototype);
                break;
            case "ServiceAccountCredentialsBaseForSaasGcp":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsBaseForSaasGcp.prototype);
                break;
            case "ServiceAccountCredentialsBaseForServiceNow":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsBaseForServiceNow.prototype);
                break;
            case "ServiceAccountCredentialsBaseForVmwareVcd":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsBaseForVmwareVcd.prototype);
                break;
            case "ServiceAccountCredentialsForAnthropicPlatform":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForAnthropicPlatform.prototype);
                break;
            case "ServiceAccountCredentialsForAppDynamics":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForAppDynamics.prototype);
                break;
            case "ServiceAccountCredentialsForAppInsights":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForAppInsights.prototype);
                break;
            case "ServiceAccountCredentialsForAwsAccessKeyProtocol":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForAwsAccessKeyProtocol.prototype);
                break;
            case "ServiceAccountCredentialsForAwsAssumeRoleProtocol":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForAwsAssumeRoleProtocol.prototype);
                break;
            case "ServiceAccountCredentialsForAzureCspApplication":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForAzureCspApplication.prototype);
                break;
            case "ServiceAccountCredentialsForAzureCspAuthorizationCode":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForAzureCspAuthorizationCode.prototype);
                break;
            case "ServiceAccountCredentialsForAzureDevops":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForAzureDevops.prototype);
                break;
            case "ServiceAccountCredentialsForAzureEaApiKey":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForAzureEaApiKey.prototype);
                break;
            case "ServiceAccountCredentialsForAzureEaApplication":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForAzureEaApplication.prototype);
                break;
            case "ServiceAccountCredentialsForAzureMcaApplication":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForAzureMcaApplication.prototype);
                break;
            case "ServiceAccountCredentialsForAzureSecurityGraphBasicAuthProtocol":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForAzureSecurityGraphBasicAuthProtocol.prototype);
                break;
            case "ServiceAccountCredentialsForAzureSecurityGraphOAuthProtocol":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForAzureSecurityGraphOAuthProtocol.prototype);
                break;
            case "ServiceAccountCredentialsForAzureSentinel":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForAzureSentinel.prototype);
                break;
            case "ServiceAccountCredentialsForAzureStack":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForAzureStack.prototype);
                break;
            case "ServiceAccountCredentialsForAzureSubscription":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForAzureSubscription.prototype);
                break;
            case "ServiceAccountCredentialsForBasicAuth":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForBasicAuth.prototype);
                break;
            case "ServiceAccountCredentialsForCloudStack":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForCloudStack.prototype);
                break;
            case "ServiceAccountCredentialsForCorestack":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForCorestack.prototype);
                break;
            case "ServiceAccountCredentialsForDockerHub":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForDockerHub.prototype);
                break;
            case "ServiceAccountCredentialsForElasticSearch":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForElasticSearch.prototype);
                break;
            case "ServiceAccountCredentialsForFreshservice":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForFreshservice.prototype);
                break;
            case "ServiceAccountCredentialsForGcpBillingAccountOauthProtocol":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForGcpBillingAccountOauthProtocol.prototype);
                break;
            case "ServiceAccountCredentialsForGcpBillingAccountServiceAccountProtocol":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForGcpBillingAccountServiceAccountProtocol.prototype);
                break;
            case "ServiceAccountCredentialsForGcpInherited":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForGcpInherited.prototype);
                break;
            case "ServiceAccountCredentialsForGcpLinkedProjectAccountOauthProtocol":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForGcpLinkedProjectAccountOauthProtocol.prototype);
                break;
            case "ServiceAccountCredentialsForGcpParentBillingAccountOauthProtocol":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForGcpParentBillingAccountOauthProtocol.prototype);
                break;
            case "ServiceAccountCredentialsForGcpParentBillingAccountServiceAccountProtocol":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForGcpParentBillingAccountServiceAccountProtocol.prototype);
                break;
            case "ServiceAccountCredentialsForGcpServiceAccountProtocol":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForGcpServiceAccountProtocol.prototype);
                break;
            case "ServiceAccountCredentialsForGitHub":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsBaseForGitHub.prototype);
                break;
            case "ServiceAccountCredentialsForGitHubAppProtocol":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForGitHubAppProtocol.prototype);
                break;
            case "ServiceAccountCredentialsForGitHubPersonalAccessTokenProtocol":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForGitHubPersonalAccessTokenProtocol.prototype);
                break;
            case "ServiceAccountCredentialsForJenkins":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForJenkins.prototype);
                break;
            case "ServiceAccountCredentialsForJiraDatacenter":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForJiraDatacenter.prototype);
                break;
            case "ServiceAccountCredentialsForJiraServiceManagementBasicAuthProtocol":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForJiraServiceManagementBasicAuthProtocol.prototype);
                break;
            case "ServiceAccountCredentialsForJiraServiceManagementInherited":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForJiraServiceManagementInherited.prototype);
                break;
            case "ServiceAccountCredentialsForJiraServicedesk":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForJiraServicedesk.prototype);
                break;
            case "ServiceAccountCredentialsForKubernetesClusterAwsAccessKeyProtocol":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForKubernetesClusterAwsAccessKeyProtocol.prototype);
                break;
            case "ServiceAccountCredentialsForKubernetesClusterAwsAssumeRoleProtocol":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForKubernetesClusterAwsAssumeRoleProtocol.prototype);
                break;
            case "ServiceAccountCredentialsForKubernetesClusterAzureApplication":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForKubernetesClusterAzureApplication.prototype);
                break;
            case "ServiceAccountCredentialsForKubernetesClusterGcpOauthProtocol":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForKubernetesClusterGcpOauthProtocol.prototype);
                break;
            case "ServiceAccountCredentialsForKubernetesClusterGcpServiceAccountProtocol":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForKubernetesClusterGcpServiceAccountProtocol.prototype);
                break;
            case "ServiceAccountCredentialsForKubernetesClusterOci":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForKubernetesClusterOci.prototype);
                break;
            case "ServiceAccountCredentialsForKubernetesClusterOnboarded":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForKubernetesClusterOnboarded.prototype);
                break;
            case "ServiceAccountCredentialsForKubernetesClusterPlatformManaged":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForKubernetesClusterPlatformManaged.prototype);
                break;
            case "ServiceAccountCredentialsForLogstash":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForLogstash.prototype);
                break;
            case "ServiceAccountCredentialsForMicrosoftTeams":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForMicrosoftTeams.prototype);
                break;
            case "ServiceAccountCredentialsForMsVmm":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForMsVmm.prototype);
                break;
            case "ServiceAccountCredentialsForNagios":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForNagios.prototype);
                break;
            case "ServiceAccountCredentialsForNewrelic":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForNewrelic.prototype);
                break;
            case "ServiceAccountCredentialsForOci":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForOci.prototype);
                break;
            case "ServiceAccountCredentialsForOpenStack":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForOpenStack.prototype);
                break;
            case "ServiceAccountCredentialsForPrivateCloud":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForPrivateCloud.prototype);
                break;
            case "ServiceAccountCredentialsForPrometheus":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForPrometheus.prototype);
                break;
            case "ServiceAccountCredentialsForQualys":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForQualys.prototype);
                break;
            case "ServiceAccountCredentialsForRackspace":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForRackspace.prototype);
                break;
            case "ServiceAccountCredentialsForRedhatSatellite":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForRedhatSatellite.prototype);
                break;
            case "ServiceAccountCredentialsForSaas":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsBaseForSaas.prototype);
                break;
            case "ServiceAccountCredentialsForSaasAssumeRoleProtocol":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForSaasAwsAssumeRoleProtocol.prototype);
                break;
            case "ServiceAccountCredentialsForSaasAwsAccessKeyProtocol":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForSaasAwsAccessKeyProtocol.prototype);
                break;
            case "ServiceAccountCredentialsForSaasAzureApplication":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForSaasAzureApplication.prototype);
                break;
            case "ServiceAccountCredentialsForSaasGcpOauthProtocol":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForSaasGcpOauthProtocol.prototype);
                break;
            case "ServiceAccountCredentialsForSaasGcpServiceAccountProtocol":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForSaasGcpServiceAccountProtocol.prototype);
                break;
            case "ServiceAccountCredentialsForSaasOci":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForSaasOci.prototype);
                break;
            case "ServiceAccountCredentialsForSaasOnboarded":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForSaasOnboarded.prototype);
                break;
            case "ServiceAccountCredentialsForServiceNowBasicAuthProtocol":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForServiceNowBasicAuthProtocol.prototype);
                break;
            case "ServiceAccountCredentialsForServiceNowOauthProtocol":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForServiceNowOauthProtocol.prototype);
                break;
            case "ServiceAccountCredentialsForTclItsm":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForTclItsm.prototype);
                break;
            case "ServiceAccountCredentialsForTenableNessus":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForTenableNessus.prototype);
                break;
            case "ServiceAccountCredentialsForVcenter":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForVcenter.prototype);
                break;
            case "ServiceAccountCredentialsForVmware":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForVmware.prototype);
                break;
            case "ServiceAccountCredentialsForVmwareVcdMaster":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForVmwareVcdMaster.prototype);
                break;
            case "ServiceAccountCredentialsForVmwareVcdOrganizationVdc":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForVmwareVcdOrganizationVdc.prototype);
                break;
            case "ServiceAccountCredentialsForZabbix":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForZabbix.prototype);
                break;
            case "ServiceAccountCredentialsForZohoServiceDeskCloud":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForZohoServiceDeskCloud.prototype);
                break;
            case "ServiceAccountCredentialsForZohoServiceDeskOnPremise":
                Object.setPrototypeOf(obj, models.ServiceAccountCredentialsForZohoServiceDeskOnPremise.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof ServiceAccountCredentialsBase)[] {
        return [
            models.ServiceAccountCredentialsBaseForAiPlatform,
            models.ServiceAccountCredentialsBaseForAws,
            models.ServiceAccountCredentialsBaseForAzure,
            models.ServiceAccountCredentialsBaseForAzureApiKey,
            models.ServiceAccountCredentialsBaseForAzureApplication,
            models.ServiceAccountCredentialsBaseForAzureCsp,
            models.ServiceAccountCredentialsBaseForAzureSecurityGraph,
            models.ServiceAccountCredentialsBaseForGcp,
            models.ServiceAccountCredentialsBaseForGcpOauthProtocol,
            models.ServiceAccountCredentialsBaseForGcpServiceAccountProtocol,
            models.ServiceAccountCredentialsBaseForKubernetesCluster,
            models.ServiceAccountCredentialsBaseForKubernetesClusterAws,
            models.ServiceAccountCredentialsBaseForKubernetesClusterGcp,
            models.ServiceAccountCredentialsBaseForOci,
            models.ServiceAccountCredentialsBaseForOpenStack,
            models.ServiceAccountCredentialsBaseForSaasAws,
            models.ServiceAccountCredentialsBaseForSaasGcp,
            models.ServiceAccountCredentialsBaseForServiceNow,
            models.ServiceAccountCredentialsBaseForVmwareVcd,
            models.ServiceAccountCredentialsForAnthropicPlatform,
            models.ServiceAccountCredentialsForAppDynamics,
            models.ServiceAccountCredentialsForAppInsights,
            models.ServiceAccountCredentialsForAwsAccessKeyProtocol,
            models.ServiceAccountCredentialsForAwsAssumeRoleProtocol,
            models.ServiceAccountCredentialsForAzureCspApplication,
            models.ServiceAccountCredentialsForAzureCspAuthorizationCode,
            models.ServiceAccountCredentialsForAzureDevops,
            models.ServiceAccountCredentialsForAzureEaApiKey,
            models.ServiceAccountCredentialsForAzureEaApplication,
            models.ServiceAccountCredentialsForAzureMcaApplication,
            models.ServiceAccountCredentialsForAzureSecurityGraphBasicAuthProtocol,
            models.ServiceAccountCredentialsForAzureSecurityGraphOAuthProtocol,
            models.ServiceAccountCredentialsForAzureSentinel,
            models.ServiceAccountCredentialsForAzureStack,
            models.ServiceAccountCredentialsForAzureSubscription,
            models.ServiceAccountCredentialsForBasicAuth,
            models.ServiceAccountCredentialsForCloudStack,
            models.ServiceAccountCredentialsForCorestack,
            models.ServiceAccountCredentialsForDockerHub,
            models.ServiceAccountCredentialsForElasticSearch,
            models.ServiceAccountCredentialsForFreshservice,
            models.ServiceAccountCredentialsForGcpBillingAccountOauthProtocol,
            models.ServiceAccountCredentialsForGcpBillingAccountServiceAccountProtocol,
            models.ServiceAccountCredentialsForGcpInherited,
            models.ServiceAccountCredentialsForGcpLinkedProjectAccountOauthProtocol,
            models.ServiceAccountCredentialsForGcpParentBillingAccountOauthProtocol,
            models.ServiceAccountCredentialsForGcpParentBillingAccountServiceAccountProtocol,
            models.ServiceAccountCredentialsForGcpServiceAccountProtocol,
            models.ServiceAccountCredentialsBaseForGitHub,
            models.ServiceAccountCredentialsForGitHubAppProtocol,
            models.ServiceAccountCredentialsForGitHubPersonalAccessTokenProtocol,
            models.ServiceAccountCredentialsForJenkins,
            models.ServiceAccountCredentialsForJiraDatacenter,
            models.ServiceAccountCredentialsForJiraServiceManagementBasicAuthProtocol,
            models.ServiceAccountCredentialsForJiraServiceManagementInherited,
            models.ServiceAccountCredentialsForJiraServicedesk,
            models.ServiceAccountCredentialsForKubernetesClusterAwsAccessKeyProtocol,
            models.ServiceAccountCredentialsForKubernetesClusterAwsAssumeRoleProtocol,
            models.ServiceAccountCredentialsForKubernetesClusterAzureApplication,
            models.ServiceAccountCredentialsForKubernetesClusterGcpOauthProtocol,
            models.ServiceAccountCredentialsForKubernetesClusterGcpServiceAccountProtocol,
            models.ServiceAccountCredentialsForKubernetesClusterOci,
            models.ServiceAccountCredentialsForKubernetesClusterOnboarded,
            models.ServiceAccountCredentialsForKubernetesClusterPlatformManaged,
            models.ServiceAccountCredentialsForLogstash,
            models.ServiceAccountCredentialsForMicrosoftTeams,
            models.ServiceAccountCredentialsForMsVmm,
            models.ServiceAccountCredentialsForNagios,
            models.ServiceAccountCredentialsForNewrelic,
            models.ServiceAccountCredentialsForOci,
            models.ServiceAccountCredentialsForOpenStack,
            models.ServiceAccountCredentialsForPrivateCloud,
            models.ServiceAccountCredentialsForPrometheus,
            models.ServiceAccountCredentialsForQualys,
            models.ServiceAccountCredentialsForRackspace,
            models.ServiceAccountCredentialsForRedhatSatellite,
            models.ServiceAccountCredentialsBaseForSaas,
            models.ServiceAccountCredentialsForSaasAwsAssumeRoleProtocol,
            models.ServiceAccountCredentialsForSaasAwsAccessKeyProtocol,
            models.ServiceAccountCredentialsForSaasAzureApplication,
            models.ServiceAccountCredentialsForSaasGcpOauthProtocol,
            models.ServiceAccountCredentialsForSaasGcpServiceAccountProtocol,
            models.ServiceAccountCredentialsForSaasOci,
            models.ServiceAccountCredentialsForSaasOnboarded,
            models.ServiceAccountCredentialsForServiceNowBasicAuthProtocol,
            models.ServiceAccountCredentialsForServiceNowOauthProtocol,
            models.ServiceAccountCredentialsForTclItsm,
            models.ServiceAccountCredentialsForTenableNessus,
            models.ServiceAccountCredentialsForVcenter,
            models.ServiceAccountCredentialsForVmware,
            models.ServiceAccountCredentialsForVmwareVcdMaster,
            models.ServiceAccountCredentialsForVmwareVcdOrganizationVdc,
            models.ServiceAccountCredentialsForZabbix,
            models.ServiceAccountCredentialsForZohoServiceDeskCloud,
            models.ServiceAccountCredentialsForZohoServiceDeskOnPremise,
        ];
    }

    fixupFields() {
    }

}
